import type { SVGProps } from 'react';
const SvgChristmas = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    fontSize="1rem"
    {...props}
  >
    <path
      stroke="#FF073B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.332}
      d="m16.725 13.413 2.835 3.11a.94.94 0 0 1-.661 1.6H5.1a.95.95 0 0 1-.86-.583.94.94 0 0 1 .198-1.018l2.835-3.109h-.283a.95.95 0 0 1-.86-.583.94.94 0 0 1 .198-1.018l2.836-3.109h-.19a.95.95 0 0 1-.94-.537.94.94 0 0 1 .184-1.064L12 3.05 15.78 7.1a.942.942 0 0 1-.756 1.602h-.189l2.835 3.109a.941.941 0 0 1-.661 1.601zM12 20.95v-2.827"
    />
  </svg>
);
export default SvgChristmas;
